import * as tslib_1 from "tslib";
import { Component, Input } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
let MissingComponentComponent = class MissingComponentComponent {
};
MissingComponentComponent.ɵfac = function MissingComponentComponent_Factory(t) { return new (t || MissingComponentComponent)(); };
MissingComponentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MissingComponentComponent, selectors: [["sc-missing-component"]], inputs: { rendering: "rendering" }, decls: 5, vars: 1, consts: [[2, "background", "darkorange", "outline", "5px solid orange", "padding", "10px", "color", "white", "max-width", "500px"]], template: function MissingComponentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "h2");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "p");
        ɵngcc0.ɵɵtext(4, "JSS component is missing Angular component implementation.");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.rendering.componentName);
    } }, encapsulation: 2 });
tslib_1.__decorate([
    Input()
], MissingComponentComponent.prototype, "rendering", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MissingComponentComponent, [{
        type: Component,
        args: [{
                selector: 'sc-missing-component',
                template: `
<div style="background: darkorange; outline: 5px solid orange; padding: 10px; color: white; max-width: 500px;">
  <h2>{{ rendering.componentName }}</h2>
  <p>JSS component is missing Angular component implementation.</p>
</div>`
            }]
    }], null, { rendering: [{
            type: Input
        }] }); })();
export { MissingComponentComponent };
